import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  paymentOnDelivery: false,
};

export const preRegisterDetailsSlice = createSlice({
  name: "preRegisterDetails",
  initialState,
  reducers: {
    updatePreRegisterDetails: (state, action) => {
      return { ...action.payload };
    },
    resetPreRegisterDetails: () => initialState,
  },
});

export const { updatePreRegisterDetails, resetPreRegisterDetails } =
  preRegisterDetailsSlice.actions;

export const preRegisterDetails = (state) => state.preRegisterDetails;
export default preRegisterDetailsSlice.reducer;
